import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { FC } from 'react';
import { submitAuthFormButton } from '@/routes/_auth/page.css.ts';
import { deleteConfirmationActions } from '../post-card/post-card-actions/post-card-actions-menu.css.ts';
import { useSetUsername } from '../set-username/use-set-username.ts';

export const SetXComHandleModal: FC<{
  username: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSetUsername?: (username: string) => void;
}> = ({ username, open, onOpenChange, onSetUsername }) => {
  const [setUsername, result] = useSetUsername();
  const toast = useToast();

  const handleSetUsername = async () => {
    try {
      await setUsername(username as string);
      onOpenChange(false);
      onSetUsername?.(username);
    } catch (e) {
      toast.error({ title: String(e) });
    }
  };

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Use X handle</ModalTitle>
        </ModalHeader>
        Do you want to change your username to {username}?
        <div className={deleteConfirmationActions}>
          <Button
            onClick={() => onOpenChange(false)}
            className={submitAuthFormButton}
            disabled={result.loading}
            variant={'secondary'}
          >
            Skip for now
          </Button>

          <Button
            className={submitAuthFormButton}
            onClick={handleSetUsername}
            loading={result.loading}
          >
            Use X handle
          </Button>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
